import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Heart } from "lucide-react";
import { getProduct } from "@/lib/api";
import { useStore } from "@/context/StoreContext";
import { ProductCard } from "@/components/ProductCard";

export default function Wishlist() {
  const { wishlist } = useStore();
  const { data: products = [], isLoading } = useQuery({
    queryKey: ["wishlist", wishlist.join(",")],
    queryFn: async () => (await Promise.all(wishlist.map((h) => getProduct(h).catch(() => null)))).filter(Boolean),
    enabled: wishlist.length > 0,
  });

  return (
    <div>
      <section className="relative bg-[#0A0A0A] text-[#F4F2ED] grain">
        <div className="relative z-10 px-5 sm:px-8 lg:px-12 py-16 sm:py-24">
          <p className="overline text-[#C6A15B]">Saved for later</p>
          <h1 className="font-hero text-6xl sm:text-8xl mt-3 leading-none">WISHLIST</h1>
        </div>
      </section>

      <section className="px-5 sm:px-8 lg:px-12 py-14 min-h-[40vh]">
        {wishlist.length === 0 ? (
          <div className="flex flex-col items-center justify-center gap-5 py-24 text-center" data-testid="wishlist-empty">
            <Heart size={40} strokeWidth={1} className="text-black/30" />
            <p className="font-body text-black/50">Nothing saved yet. Tap the heart on any piece to keep it here.</p>
            <Link to="/collections/new" className="btn-fill">Discover the Drop</Link>
          </div>
        ) : isLoading ? (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-10">
            {wishlist.map((h) => <div key={h} className="aspect-[3/4] bg-[#EAE8E2] animate-pulse" />)}
          </div>
        ) : (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-10">
            {products.map((p, i) => <ProductCard key={p.handle} product={p} index={i} />)}
          </div>
        )}
      </section>
    </div>
  );
}
